/**
 * Object containing regular expressions.
 *
 * Using getters ensures a new RegExp instance is created on each access,
 * preventing unexpected behavior with the global (`g`) and case-insensitive (`i`) flags.
 */
export const RegExp = {
  get email() {
    return /^(?![._+-])(?=.{1,64}@)([a-zA-Z0-9]+(?:[._+-][a-zA-Z0-9]+)*)@(?=.{1,255}$)(?:(?!-)[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}$/i;
  },
  get onlyLetters() {
    return /[^a-zA-Z]+/g;
  },
  get url() {
    return /^(https?|ldaps?):\/\/(?:www\.|(?!www))((([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})|(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}))(:\d+)?(\/[\w\-.~!$&'()*+,;=:@%]*)*(\?[\w\-.~!$&'()*+,;=:@%_/?=]*)?(#[\w\-.~!$&'()*+,;=:@%/_]*)?$/i;
  },
  domain(useOnlyDomain = true) {
    if (useOnlyDomain) {
      /* Domain of URL or IP-address with optional port */
      return /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    }

    /* Domain that can contain protocols (HTTP, HTTPS, LDAP, LDAPS) or URL routes */
    return /^(?:(https?|ldaps?):\/\/)?((?:[a-zA-Z0-9](?!.*--)(?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})(\/[^\s]*)?$/i;
  },
};
